import objectAssign from 'object-assign';
import { combineReducers } from 'redux';
import { trackEvent } from './libs';
import {
  SET_CAR_LIST,
  SET_BROCHURES,
  SET_USER_NAME,
  SET_USER_EMAIL,
  SET_USER_AGREE,
  SET_SUBMIT_STATUS,
  RESET,
} from './actions';

const initialState = {
  carList: [],
  brochures: [],
  name: null,
  email: null,
  news_subscription: false,
  submitStatus: null,
};

function mainReducer(state = initialState, action) {
  switch (action.type) {
    case SET_CAR_LIST:
      return objectAssign({}, state, {carList: action.carList});

    case SET_BROCHURES: // eslint-disable-line no-case-declarations
      let brochures = [...state.brochures, action.brochures];

      if (state.brochures.some(i => i.name === action.brochures.name)) {
        brochures = state.brochures.filter(i => i.name !== action.brochures.name);
      }

      trackEvent({
        eventCategory: 'Brochure',
        eventAction: 'Add To Send Button',
        eventLabel: action.brochures.name,
      });

      return objectAssign({}, state, { brochures });

    case SET_USER_NAME:

      return objectAssign({}, state, {name: action.name});

    case SET_USER_EMAIL:
      return objectAssign({}, state, {email: action.email});

    case SET_USER_AGREE:
      return objectAssign({}, state, {news_subscription: action.news_subscription});

    case SET_SUBMIT_STATUS:
      return objectAssign({}, state, {submitStatus: action.submitStatus});

    case RESET:
      return objectAssign({}, state, {
        brochures: initialState.brochures,
        name: initialState.name,
        email: initialState.email,
        news_subscription: initialState.news_subscription,
        submitStatus: initialState.submitStatus,
      });

    default:
      return state;
  }
}

const rootReducer = combineReducers({
  mainReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers.js